import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from './banner/banner.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HomeHeaderComponent } from './home-header/home-header.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { SharedModule } from '../shared/shared.module';
import { HomeBannerComponent } from './home-banner/home-banner.component';
import { AppLoadService } from './services/app-load-service';
import { ReactiveFormsModule } from '@angular/forms';

export function initApp(appLoadService: AppLoadService) {
  return () => appLoadService.initApp();
}

@NgModule({
  declarations: [
    BannerComponent,
    FooterComponent,
    HeaderComponent,
    HomeHeaderComponent,
    NavBarComponent,
    HomeBannerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule
  ],
exports:[   BannerComponent,
  FooterComponent,
  HeaderComponent,
  HomeHeaderComponent,
  NavBarComponent
],
providers:[
  {
    provide: APP_INITIALIZER,
    useFactory: initApp,
    deps: [AppLoadService],
    multi: true,
  },
]
})
export class CoreModule { }
